import { jsx as _jsx } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsx("g", {
    children: /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M 5,4 H 28 L 18.535874,15 18.453432,25 13,27 V 15 L 4,4 h 1"
    })
  });
});